import React from 'react';
import './App.css';
import { Container, Row, Col, Button } from 'reactstrap';

function Home() {

    return (
        <Container>
            <Row>
                <Col className="bg-azul text-center pt-5 mt-5" style={{'borderRadius': '30px 30px 0px 0px'}}>
                    <img src="logo.png" alt="Logo FIKM" style={{'width': '50%'}}></img>
                </Col>
            </Row>
            <Row>
                <Col className="bg-azul h5 text-white pt-3 pb-5 text-center" style={{'borderRadius': '0px 0px 30px 30px'}}>
                    FEDERAÇÃO INTERNACIONAL<br />DE KRAV MAGÁ
                </Col>
            </Row>
            <Row>
                <Col className="mt-4">
                    <Button href="/login" className="btn btn-block btn-lg btn-info btn-azul">ENTRE</Button>
                </Col>
            </Row>
            <Row>
                <Col className="mt-4">
                    <Button href="/cadastro" className="btn btn-block btn-lg btn-outline-primary btn-outline-azul">CADASTRE-SE</Button>
                </Col>
            </Row>
            <Row>
                <Col className="small text-center mt-3">
                    v1.10.0
                </Col>
            </Row>
        </Container>
        
    );
}

export default Home;
